<template>
  <div
    :class="(is_show ? 'blueBorder' : '') + ' carSystem' + (checked ? ' checked' : '')"
    :style="{ width: width + 'px' }"
    ref="option"
  >
    <a href="javascript:;" class="defaultText" @click="toggle">{{ selected_text }}</a>
    <transition name="gas-select">
      <div
        class="unclick"
        v-show="is_show && (typeof options === 'undefined' || options.length === 0)"
      >
        <a href="javascript:;">请先选择品牌</a>
      </div>
    </transition>
    <transition name="gas-select">
      <div
        class="carSystemLayer"
        v-show="is_show && typeof options !== 'undefined' && options.length > 0"
        :style="position"
      >
        <div class="carlayerTitle">
          <span><a href="javascript:;">全部</a></span>
        </div>
        <div class="carlayerBox2">
          <dl v-for="(option, index) in options" :key="index">
            <dt>{{ option.brand.brandName }}</dt>
            <dd>
              <ul>
                <li
                  v-for="(model, index) in option.modelLines"
                  :key="index"
                  @click="choice(model)"
                  :class="value === model ? 'checked' : ''"
                >
                  <a href="javascript:;">{{ model }}</a>
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "select-group",
  props: {
    value: String,
    text: String,
    position: String,
    width: Number,
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selected_text: this.text,
      selected_text_list: [],
      data_index: 1, // 文本数据位置
      is_show: false,
      checked: false,
    };
  },
  computed: {
    options_new() {
      if (Object.keys(this.options).length > 0) {
        return JSON.parse(JSON.stringify(this.options));
      }
      return {};
    },
  },
  watch: {
    options_new(new_val, old_val) {
      if (JSON.stringify(new_val) != JSON.stringify(old_val)) {
        this.selected_text = this.text;
        this.checked = false;
        this.$emit("input", "");
      }
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.$refs.option) {
        if (!this.$refs.option.contains(e.target)) {
          this.hide();
        }
      }
    });
  },
  methods: {
    toggle() {
      this.is_show = !this.is_show;
    },
    choice(option) {
      //   let choiced_value = option;
      this.selected_text = option;
      //   if (this.value.indexOf(choiced_value) >= 0) {
      //     this.value.splice(this.value.indexOf(choiced_value), 1);
      //   } else {
      //     this.value.push(choiced_value);
      //   }

      this.checked = true;
      this.$emit("input", option);
      this.$emit("reset");
      this.hide();
    },
    hide() {
      this.is_show = false;
    },
  },
};
</script>
